import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/violation-tickets/{-$id}')({
  beforeLoad: () => getTitleContextSlice('Violation Tickets'),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
